module.exports = __webpack_public_path__ + "img/kamohara-sensei.5faf9e58.jpg";